const WarningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M5.51609 36.6667H34.4836C37.4457 36.6667 39.2923 33.3936 37.8112 30.7869L23.3274 5.28836C21.8464 2.68166 18.1533 2.68166 16.6722 5.28836L2.18848 30.7869C0.707405 33.3936 2.55394 36.6667 5.51609 36.6667ZM19.9998 23.3333C18.9419 23.3333 18.3332 22.5 18.3332 21.6667V19.0274L18.3332 16.6667C18.3332 15.8333 18.9419 15 19.9998 15C21.0577 15 21.6665 15.8333 21.6665 16.6667L21.6665 19.0274V21.6667C21.6665 22.5 21.0577 23.3333 19.9998 23.3333ZM21.6665 30H18.3332L18.3332 26.6667H21.6665L21.6665 30Z"
        fill="#F7BA1E"
      />
    </svg>
  )
}

export default WarningIcon
